/* eslint-disable no-console */

const DEV = true;

const logger = {
  log: (name: string, ...args: Array<any>) => {
    if (DEV) {
      console.log(`%c START ERROR LOG - ${name}: `, "background: green; color: #fff;");
      console.log(args);
      console.log(`%c END ERROR LOG - ${name}`, "background: green; color: #fff;");
    }
  },
  error: (name: string, ...args: Array<any>) => {
    if (DEV) {
      console.error(`%c START ERROR LOG - ${name}: `, "background: red; color: #fff;");
      console.error(args);
      console.error(`%c END ERROR LOG - ${name}`, "background: red; color: #fff;");
    }
  }
};

export default logger;
